import React from 'react';
import { connect } from 'react-redux';
import { fetchNews } from '../actions';
import Helmet from '../components/Helmet';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useDeepCompareEffect from 'use-deep-compare-effect'
import Container from '../components/Container';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
}));

const NewsPage = (props) => {

    const theme = useTheme();
    const { news } = props;
    const classes = useStyles(news);

    useDeepCompareEffect(() => {
        if (!news.isLoaded) {
            props.fetchNews();
        }
    }, [news])

    if (!news.isLoaded) {
        return <div>Loading...</div>;
    }
 
    return (
        <div className={classes.container}>
            <Helmet {...news} />

            <Container>
                <Grid container alignContent="center" justify="center" spacing={1}>
                    {news.items.map((d, i) => {
                        return (
                            <Grid item lg={4} key={i}>
                                 <div className="fb-post" data-href={d} data-show-text="true" data-width=""></div>
                            </Grid>
                        )
                    })}
                </Grid>    
            </Container>
        </div>
    )
}

function mapStateToProps({ news }) {
    return { news };
}

export default {
    loadData: ({ dispatch }) => dispatch(fetchNews()),
    component:  connect(mapStateToProps, { fetchNews }) (NewsPage)
}



// WEBPACK FOOTER //
// ./src/client/pages/NewsPage.js